export default __webpack_public_path__ + "static/banner-aa49a7375b7af299d620f48a180df14c.png";